import React from 'react';
import { cn } from '../../utils/cn';
import type { ToolbarButtonProps } from './types';

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  onClick,
  isActive = false,
  disabled = false,
  title,
  children,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={cn(
      'p-1.5 rounded hover:bg-gray-200 transition-colors disabled:opacity-40 disabled:cursor-not-allowed',
      isActive && 'bg-gray-300',
      className
    )}
    title={title}
  >
    {children}
  </button>
);

export const Divider: React.FC = () => <div className="w-px h-6 bg-gray-300 mx-1" />;
